import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[bsDatepicker][readonly]',
  standalone: true
})
export class BsDatepickerReadonlyFixDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('focus')
  @HostListener('mouseenter')
  onHandle(): void {
    this.el.nativeElement.readOnly = true;
  }
}
